import { zodResolver } from '@hookform/resolvers/zod';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Controller, useForm } from 'react-hook-form';
import { z } from 'zod';
import { AppointmentSurvey } from '../../../../data-access/appointmentProposals';

type Notes = Pick<AppointmentSurvey, 'notes'>;

type NotesSectionProps = {
  defaultValues: Notes;
  formId?: string;
  onSubmit: (data: Notes) => Promise<void>;
};

export type NotesSectionInputs = Notes;

const NotesSchema = z.object({
  notes: z.string(),
});

const NotesSection: React.FC<NotesSectionProps> = ({
  defaultValues,
  formId,
  onSubmit,
}) => {
  const { control, handleSubmit } = useForm<NotesSectionInputs>({
    resolver: zodResolver(NotesSchema),
    defaultValues,
  });

  return (
    <Box
      component={'form'}
      id={formId}
      onSubmit={handleSubmit(onSubmit)}
      autoComplete="off"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: '100%',
      }}
    >
      <Controller
        control={control}
        name="notes"
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            label="Add Note"
            fullWidth
            multiline
            rows={4}
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
    </Box>
  );
};

export default NotesSection;
